/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/ustrichnyj-bar-:id'>.
 * префикс-параметр, был '/ustrichnyj-bar-:id'
 */
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import OysterBarIdPage from '@routes/OysterBarId';
import { getQueryClient } from '../providers/query';
import { shopsQueryOptions } from '@queries/shops';

export const Route = createFileRoute('/ustrichnyj-bar-{$id}')({
  staticData: { layout: { landingFooter: true, withoutHeader: true, withoutFooter: true } },
  /**
   * ЭТАП 2 — честный 404 несуществующего бара.
   *
   * ОСОБЕННОСТЬ: отдельного метода «получить бар по identify» у бэка НЕТ.
   * Страница ищет свой бар перебором в общем списке магазинов:
   * `shops.find(shop => shop.identify === params.id)` (routes/OysterBarId).
   * Значит и проверка существования — это тот же поиск по ответу getShops,
   * а не текст ошибки и не отдельный запрос. Список всё равно нужен трём
   * блокам страницы, поэтому ensureQueryData дедуплицируется с
   * root-префетчем и лишнего обращения не делает.
   *
   * Раньше несуществующий identify давал HTTP 200 и «полупустой» лендинг:
   * shopInfo === undefined, баннер бара не рендерился, а всё остальное
   * рисовалось как ни в чём не бывало.
   *
   * ЭТАП 3 п.3 — ТИП МАГАЗИНА ТЕПЕРЬ ПРОВЕРЯЕМ, но не 404-м. Аудит
   * LazarServer снял неопределённость: в проде неустричный магазин по этому
   * адресу отдавал 301 на общий лендинг — `lib/routes/shop.ts`,
   * `itemType === null || itemType.value !== 'oyster_bar'` ->
   * `res.redirect(301, '/ustrichnye-bary-v-moskve')`. То есть правильный
   * ответ на бывший открытый вопрос — не 404 и не 200, а редирект: адрес
   * существует, но принадлежит другому разделу, и его вес нужно склеить с
   * лендингом баров. Магазин без типа тоже уходит на лендинг — как в проде.
   * Разбор — в `docs/SSR_LAZARSERVER_AUDIT.md`, п.5.
   */
  loader: async ({ params }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    const queryClient = getQueryClient();
    let data;
    try {
      data = await queryClient.ensureQueryData(shopsQueryOptions());
    } catch {
      // Сетевой сбой — это не «страницы нет»: отдаём страницу как раньше,
      // клиент повторит запрос сам
      return;
    }
    const bar = (data?.getShops ?? []).find(
      shop => shop?.identify === params.id
    );
    if (!bar) {
      throw notFound();
    }
    if (bar.type !== 'oyster_bar') {
      throw redirect({
        to: '/ustrichnye-bary-v-moskve',
        statusCode: 301
      });
    }
  },
  component: () => (
    <CacheDataRoute component={OysterBarIdPage} path='/ustrichnyj-bar-:id' />
  )
});
